import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  jsonLd?: object[];
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function useSeo({ title, description, jsonLd = [] }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);

    // 注入 JSON-LD 结构化数据
    const existing = document.querySelectorAll("script[data-seo-jsonld]");
    existing.forEach((el) => el.remove());
    jsonLd.forEach((data) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "true");
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    });
  }, [title, description, JSON.stringify(jsonLd)]);
}